import axios from 'axios';
import logComponent from '../logComponent';
import getConfig from './getConfig';

const Mood = (function() {
  function Get() {
    if (logComponent('Mood')) { console.debug('Mood Get'); }
    return axios.get('api/Mood', getConfig());
  }

  return {
    Get
  }
})();

export default Mood;